













import { Vue, Component, Prop, Model } from 'vue-property-decorator';

import { MINUTES_IN_HOUR } from '@/utils/date';
import { ISOTime } from '@/utils/date/types';

const TIMEPICKER_MINUTES_MINIMAL_STEP = 5;
const validateStep = (step: number) => step % TIMEPICKER_MINUTES_MINIMAL_STEP === 0;

@Component({
})
export default class BaseTimepicker extends Vue {
    @Model('update:time', { required: true }) time!: ISOTime
    @Prop({ default: 'Время' }) placeholder!: string
    @Prop({ default: '00:00' }) min!: string
    @Prop({ default: '24:00' }) max!: string
    @Prop({ default: 15, validator: validateStep }) step!: number
    @Prop({ default: false }) disabled!: boolean

    get timeModel() {
        return this.time;
    }

    set timeModel(time) {
        this.$emit('update:time', time);
    }

    get allowedMinutes() {
        const allowedMinutes = [];

        for (let minute = 0; minute <= MINUTES_IN_HOUR; minute += this.step) {
            allowedMinutes.push(minute);
        }

        return allowedMinutes;
    }

    get themeColor() {
        if (this.disabled) {
            return '#aaa';
        }

        return '#6e258b';
     }

    change() {
        this.$emit('change');
    }
}
